import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface TestRangeItem {
  TestMethod: string;
  AgeProfile: string;
  MinValue: number;
  MaxValue: number;
  UOM: string;
  NormalValue?: number;
  MinReportText?: string;
  MaxReportText?: string;
}

@Component({
  selector: 'ngbtestrange',
  templateUrl: './testrange.modal.html',
  styleUrls: ['./testrange.modal.scss']
})

export class NgbTestRangeModal implements OnInit {
  @Input() TestName: string = 'RBC';
  @Input() ObservationName: string = 'A/G RATIO';
  @Input() RangeList: TestRangeItem[] = [];

  public Range: boolean = true; 
  public Edit: boolean = false; 
  public ShowList: boolean = false;

  public currentItem: TestRangeItem = {
    TestMethod: 'EC',
    AgeProfile: 'Female',
    MinValue: 3,
    MaxValue: 4,
    UOM: 'Ratio',
    NormalValue: 3.5,
    MinReportText: 'Low',
    MaxReportText: 'High'
  };

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    if (!this.RangeList || this.RangeList.length === 0) {
      this.RangeList = [
        { TestMethod: 'EC', AgeProfile: 'Female', MinValue: 3, MaxValue: 4, UOM: 'Ratio', NormalValue: 3.5 },
        { TestMethod: 'EC', AgeProfile: 'Male', MinValue: 11, MaxValue: 15, UOM: 'Ratio', NormalValue: 13 }
      ];
    }
  }
 
  onSubmit() {
    this.activeModal.close(this.RangeList);
  }

  saveCurrentItem() {
    this.RangeList.push({ ...this.currentItem });
    this.Back();
  }

  ModalClose() {
    this.activeModal.close(this.RangeList);
  }

  edit1(item?: TestRangeItem) {
    if (item) {
      this.currentItem = { ...item };
    }
    this.Range = false;
    this.Edit = true;
    this.ShowList = false;
  }

  Add() {
    this.currentItem = {
      TestMethod: 'EC',
      AgeProfile: 'Female',
      MinValue: 0,
      MaxValue: 10,
      UOM: 'Ratio',
      NormalValue: 5,
      MinReportText: '',
      MaxReportText: ''
    };
    this.Range = false;
    this.Edit = false;
    this.ShowList = true;
  }

  Back() {
    this.Range = true;
    this.Edit = false;
    this.ShowList = false;
  }
}
